module.exports = __webpack_public_path__ + "static/img/img-home-co-14.b24993e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-14.png
// module id = oS2X
// module chunks = 1